export { FlexItem } from "./component";
export type { AlignSelf, FlexItemProps } from "./types";
